(() => {
 if (window.skClayPurchaseInit) return;
 window.skClayPurchaseInit = true;

 document.addEventListener('click', event => {
  const link = event.target.closest('a[data-sk-purchase-link]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const target = document.getElementById('product-purchase');
  if (!target) return;
  event.preventDefault();
  const header = document.querySelector('.section-header');
  const offset = (header?.getBoundingClientRect().height || 0) + 16;
  const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - offset);
  window.history.replaceState(window.history.state, '', '#product-purchase');
  target.focus({preventScroll: true});
  window.scrollTo({top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
 });

 document.addEventListener('click', event => {
  const button = event.target.closest('.sk-clay-summary__toggle');
  if (!button) return;
  const points = document.getElementById(button.getAttribute('aria-controls'));
  if (!points) return;
  const expanded = button.getAttribute('aria-expanded') === 'true';
  button.setAttribute('aria-expanded', String(!expanded));
  points.hidden = expanded;
  button.querySelector('span').textContent = expanded ? button.dataset.more : button.dataset.less;
 });
 if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.variantChange, event => {
   const {sectionId, html} = event.data || {};
   if (!html || !sectionId) return;
   const root = document.querySelector('product-info[data-section="' + sectionId + '"]');
   const button = root?.querySelector('.sk-clay-purchase button[name="add"]');
   const source = html.getElementById('ProductSubmitButton-' + sectionId);
   if (!button || !source) return;
   const label = button.querySelector('span');
   const sourceLabel = source.querySelector('span');
   if (label && sourceLabel) label.textContent = sourceLabel.textContent;
   const stock = root.querySelector('[id^="SkClayAvailability-"]');
   const sourceStock = html.getElementById('SkClayAvailability-' + sectionId);
   if (stock && sourceStock) {stock.innerHTML = sourceStock.innerHTML; stock.className = sourceStock.className;}
  });
 }
})();